import merge from 'lodash/merge';
import CalendarService from './services/search.service';
import ServiceProvider from './services/service.provider';
import DataProvider from './services/data.provider';
import TabsProvider from './services/tabs.provider';
import AppFilter from './views/AppFilter.svelte';
import AppFilter2 from './views/AppFilter2.svelte';
import AppList from './views/AppList.svelte';
class CalendarApp {
    constructor(options) {
        this.options = options;
    }
    mount() {
        try {
            this.prepareOptions();
            this.dataProvider = new DataProvider(this.options);
            this.tabsProvider = new TabsProvider();
            const searchService = new CalendarService(this.dataProvider, this.tabsProvider);
            this.serviceProvider = new ServiceProvider(searchService);
            this.createInstance();
        }
        catch (e) {
            console.log(e);
        }
    }
    createInstance() {
        new AppFilter({
            target: this.targetFilterElement,
            props: {
                serviceProvider: this.serviceProvider,
                dataProvider: this.dataProvider
            }
        });
        new AppFilter2({
            target: this.targetFilter2Element,
            props: {
                serviceProvider: this.serviceProvider,
                dataProvider: this.dataProvider,
                tabsProvider: this.tabsProvider,
            }
        });
        new AppList({
            target: this.targetListElement,
            props: {
                serviceProvider: this.serviceProvider,
            }
        });
    }
    get targetListElement() {
        const { listEl } = this.options;
        const element = document.querySelector(listEl);
        if (null === element) {
            throw new Error("The container for displaying list does not exist");
        }
        return element;
    }
    get targetFilterElement() {
        const { filterEl } = this.options;
        const element = document.querySelector(filterEl);
        if (null === element) {
            throw new Error("The container for displaying filter does not exist");
        }
        return element;
    }
    get targetFilter2Element() {
        const { filter2El } = this.options;
        const element = document.querySelector(filter2El);
        if (null === element) {
            throw new Error("The container for displaying filter2 does not exist");
        }
        return element;
    }
    // OPTIONS
    prepareOptions() {
        this.options = merge({}, {
            filterEl: null,
            filter2El: null,
            listEl: null,
            placeholder: null,
            cta: null,
            reset: null,
            structureKeys: null,
            groupId: null,
            showSiteUrl: null,
        }, this.options);
    }
}
const filter = document.getElementById('filter-calendar-module');
const filter2 = document.getElementById('filter2-calendar-module');
const list = document.getElementById('list-calendar-module');
if (list && filter && filter2) {
    const structureKeys = filter.getAttribute("data-structure-keys") || "";
    const groupId = filter.getAttribute('data-group-id') || "";
    const showSiteUrl = filter.getAttribute("data-show-site-url") || "false";
    const cta = filter.getAttribute("data-cta") || "Filtrovat";
    const reset = filter.getAttribute("data-ctaReset") || "Vymazat filtr";
    const placeholder = filter.getAttribute("data-placeholder") || "Vyhledat...";
    const calendarApp = new CalendarApp({
        filterEl: '#filter-calendar-module',
        filter2El: '#filter2-calendar-module',
        listEl: "#list-calendar-module",
        structureKeys,
        groupId,
        showSiteUrl: JSON.parse(showSiteUrl),
        cta,
        reset,
        placeholder,
    });
    calendarApp.mount();
}
